export const scrollingModalData = [
    {
        class: 'mt-3',
        text: "For a site to be successful, a designer must be able to communicate their ideas, chat with a firm about what they want, and inquire about the target audience."
    },
    {
        class: 'mt-2',
        text: "As a web designer, you either prefer to work freelance for several different businesses at once or you may choose to work for just one. In either case, you'll need good time management skills to keep several projects moving forward."
    },
    {
        class: 'mt-2',
        text: "Although a designer doesn't write the code that makes a site work, it doesn't hurt to have a basic understanding of HTML or CSS to make minor adjustments to a site. You'll find it simpler to edit templates, improve typefaces, or change item placements if you have a basic understanding of how things work."
    },
    {
        class: 'my-2',
        text: "Most businesses employ a certain font or typography so that clients can quickly distinguish them from their rivals. Since designers now have access to a wider variety of fonts, firms may more easily and precisely communicate their brands through typography."
    },
    {
        class: 'mt-3',
        text: "User research, persona creation, building wireframes and interactive prototypes, and testing ideas are among the common tasks of a UX designer. These duties can differ greatly between organizations."
    },
    {
        class: 'mt-3',
        text: "Create solutions that will be helpful for the issues and situations that exist right now, not for those that will. With the right materials, assist people in organizing their time, completing things more quickly, and optimizing it."
    },
    {
        class: 'mt-3',
        text: "Based on the data received from users, improve them. Adapt existing solutions to the requirements, hopes, difficulties, and expectations of users."
    },
    {
        class: 'mt-3',
        text: "Keep in mind that you are creating solutions to particular challenges for a particular population living in a particular habitat. Always remember to correctly contextualise your thoughts and determine whether they are actually appropriate for the situation. It's sometimes necessary to concede that a digital solution is not the most appropriate choice in a certain circumstance."
    }
]

export const fullscreenModalData = [
    {
        title: 'Web Design ',
        text: 'We build specialised websites for companies, list them on digital directories, and set up a sales funnel to boost ROI.'
    },
    {
        title: 'Content Marketing ',
        text: "Through better opportunities and knowledgeable marketing strategies, we aid business funnel.We won't only hit the target; instead, we'll aim higher and surpass the objectives."
    },
    {
        title: 'PPC ',
        text: "Customized advertising to increase visitors and improve conversion.To increase retention, identify the correct audience and remarket to them."
    },
    {
        title: 'UX Designer ',
        text: "The capacity to comprehend and experience other people's feelings is known as empathy.A positive consumer experience is prioritised by UX.The finest UX designers spend time studying individuals and their tendencies because of this. Designers may produce goods that genuinely engage and excite customers by having a thorough understanding of the end consumers."
    }
]

export const largeModalData = [
    {
        text: "No matter how talented you are as a content writer or creator, you will always fail if you don't have a clear set of goals."
    },
    {
        text: "First of all, without goals, there is no way to determine your success. Additionally, you lack direction."
    },
    {
        text: "Together with your team, respond to the following questions to make sure they are:"
    },
    {
        text: 'What must you achieve, and by when?'
    },
    {
        text: 'How will you evaluate your level of success?'
    },
    {
        text: 'Can you accomplish it with the available resources?'
    },
    {
        text: 'Does it advance your core business aims?'
    }
]

export const belowsmData = [
    {
        class: 'mt-3',
        text: 'For a site to be successful, a designer must be able to communicate their ideas, chat with a firm about what they want, and inquire about the target audience.'
    },
    {
        class: 'my-2',
        text: 'Most businesses employ a certain font or typography so that clients can quickly distinguish them from their rivals.Since designers now have access to a wider variety of fonts, firms may more easily and precisely communicate their brands through typography.'
    },
    {
        class: 'mt-3',
        text: 'User research, persona creation, building wireframes and interactive prototypes, and testing ideas are among the common tasks of a UX designer.These duties can differ greatly between organizations.'
    },
    {
        class: 'mt-3',
        text: "Keep in mind that you are creating solutions to particular challenges for a particular population living in a particular habitat.Always remember to correctly contextualise your thoughts and determine whether they are actually appropriate for the situation. It's sometimes necessary to concede that a digital solution is not the most appropriate choice in a certain circumstance."
    }
]

export const demoModalData = [
    {
        class: '1,908',
        text: 'Posts'
    },
    {
        class: '34.0k',
        text: 'Followers'
    },
    {
        class: '897',
        text: 'Following'
    }
]